import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import EntranceExitMarkItem from '@blade-sxp/task-management/components/entrance-exit-mark/item.vue';
import { TaskMangementModule as store } from '@blade-sxp/task-management/store/index';
import { EVENT_KEY } from '@blade-sxp/task-management/interfaces/index';
let EntranceExitMark = class EntranceExitMark extends Vue {
    entranceExitData;
    disabled;
    get isData() {
        const data = this.entranceExitData;
        let isData = false;
        Object.keys(data)?.forEach((k) => {
            const val = data[k];
            const list = val?.list;
            if ((list?.length ?? 0) > 0) {
                const isNotNull = list?.some((item) => item.name && item.list?.length > 0);
                isNotNull && (isData = true);
            }
        });
        return isData;
    }
    markIcon(iconInfo) {
        // 标记进出口
        store.updateEventData({
            eventKey: EVENT_KEY['mark'],
            type: 'icon',
            param: iconInfo,
        });
    }
    onMouseenter(iconInfo) {
        store.updateEventMap({
            key: 'hover',
            eventData: {
                eventKey: EVENT_KEY['mouseenter'],
                type: 'icon',
                param: iconInfo,
            },
        });
    }
    onMouseleave(iconInfo) {
        store.updateEventMap({
            key: 'hover',
            eventData: {
                eventKey: EVENT_KEY['mouseleave'],
                type: 'icon',
                param: iconInfo,
            },
        });
    }
};
__decorate([
    Prop()
], EntranceExitMark.prototype, "entranceExitData", void 0);
__decorate([
    Prop()
], EntranceExitMark.prototype, "disabled", void 0);
EntranceExitMark = __decorate([
    Component({
        name: 'entranceExitMark',
        components: { EntranceExitMarkItem },
    })
], EntranceExitMark);
export default EntranceExitMark;
